import { h, render, Component } from 'preact';


const  recent = (props) => (
	<svg id="recent" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<path d="M37.6,23v16.2l13.9,8.2l2.3-3.9l-11.3-6.7V23H37.6z M40.9,6.9c-16.1,0-29.1,13-29.1,29.1H2l12.6,12.6l0.2,0.5l13.1-13h-9.7c0-12.5,10.1-22.7,22.7-22.7S63.5,23.5,63.5,36S53.4,58.7,40.9,58.7c-6.2,0-11.9-2.6-16-6.7l-4.6,4.6c5.3,5.3,12.5,8.5,20.6,8.5C57,65.1,70,52.1,70,36C70,19.9,57,6.9,40.9,6.9z" />
	</svg>
);

export default recent;


// WEBPACK FOOTER //
// ../q-components/components/icons/searchIcons/recent/index.js